import { HealthRecordIndexItem, HealthRecordMeta, Patient, PatientDto, } from '@web/csl-lib-models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

@Injectable({
  providedIn: 'root'
})
export class ClinicHealthRecordService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  /*
   * Health Record CRUD
   */

  getHealthRecordIndexItemByClinic(clinicId: number, healthRecordId: string): Observable<HealthRecordIndexItem> {
    return this.http.get<HealthRecordIndexItem>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}`);
  }

  getHealthRecordIndexByClinic(userId: string, clinicId: number): Observable<HealthRecordIndexItem[]> {
    return this.http.get<HealthRecordIndexItem[]>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/index`);
  }

  getHealthRecordMeta(clinicId: number, healthRecordId: string) {
    return this.http.get<HealthRecordMeta>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/meta`);
  }

  getPatient(clinicId: number, healthRecordId: string): Observable<Patient> {
    return this.http.get<Patient>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/patient`);
  }

  updatePatient(clinicId: number, healthRecordId: string, patient: PatientDto): Observable<Patient> {
    return this.http.patch<Patient>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/patient`, patient);
  }


  /*
   * Legal Guardianship
   */

  toggleLegalGuardianship(clinicId: number, healthRecordId: string, enabled: boolean): Observable<HealthRecordMeta> {
    return this.http.patch<HealthRecordMeta>(`${this.apiUrl}/clinics/${clinicId}/healthrecords/${healthRecordId}/lg/toggle`, { enabled });
  }


}
